import { render, staticRenderFns } from "./TmpCartItem.vue?vue&type=template&id=d8838c70&scoped=true&lang=pug&"
import script from "./TmpCartItem.vue?vue&type=script&lang=js&"
export * from "./TmpCartItem.vue?vue&type=script&lang=js&"
import style0 from "./TmpCartItem.vue?vue&type=style&index=0&id=d8838c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8838c70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
